import { InputSkeleton } from '@/_components';
import {
  CardContainer,
  Container,
  ContainerLayout,
  FormLayout,
  LeftSection,
  StickyPageHeaderSkeletonWithButtons,
} from '@/_containers';

export default function Loading({ isModal = false }: { isModal?: boolean }) {
  return (
    <ContainerLayout>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={1} withBreadcrumb isModal={isModal} />

      <Container>
        <LeftSection forceFullWidth={isModal}>
          <CardContainer>
            <FormLayout>
              <InputSkeleton className="col-span-12" />
            </FormLayout>
          </CardContainer>
        </LeftSection>
      </Container>
    </ContainerLayout>
  );
}
